import { createContext, useContext, useState, useEffect } from 'react';

const ErpPaContext = createContext();

export const ErpPaProvider = ({ children }) => {
    const [erpPaId, setErpPaId] = useState(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const storedId = localStorage.getItem('erpPaId');
        if (storedId) {
            setErpPaId(storedId);
        }
        setReady(true);
    }, []);

    const saveErpPaId = (id) => {
        if (id) {
            localStorage.setItem('erpPaId', id);
            setErpPaId(id);
        }
    };

    const clearErpPaId = () => {
        localStorage.removeItem('erpPaId');
        setErpPaId(null);
    };

    return (
        <ErpPaContext.Provider
            value={{ erpPaId, saveErpPaId, clearErpPaId, ready }}
        >
            {children}
        </ErpPaContext.Provider>
    );
};

export const useErpPa = () => useContext(ErpPaContext);
